import moment from 'moment/src/moment'
import _axios from '../plugins/axios'

const state = {
    usage: [],
    summary: [], // still kept for compatibility
    balance: 0,
    paymentType: '',
    currentPage: 1,
    lastPage: 1,
    total: 0,
    loading: false,
    error: null
}
const getters = {
    getUsage: state => state.usage,
    getSummary: state => state.summary,
    getBalance: state => state.balance,
    getPaymentType: state => state.paymentType,
    getCurrentPage: state => state.currentPage,
    getLastPage: state => state.lastPage,
    getTotal: state => state.total,
    isLoading: state => state.loading,
    getError: state => state.error,

    // NEW: computed summary based on usage array
    usageSummary: state => {
        const totalRequests = state.usage.length
        const totalSearches = state.usage.reduce((sum, i) => sum + parseInt(i.search || 0), 0)
        const totalAmount = state.usage.reduce((sum, i) => sum + parseFloat(i.price || 0), 0)
        return { totalRequests, totalSearches, totalAmount }
    }
}

const mutations = {
    SET_USAGE (state, data) { state.usage = data },
    SET_SUMMARY (state, data) { state.summary = data },
    SET_BALANCE (state, data) { state.balance = data },
    SET_PAYMENT_TYPE (state, data) { state.paymentType = data },
    SET_CURRENT_PAGE (state, data) { state.currentPage = data },
    SET_LAST_PAGE (state, data) { state.lastPage = data },
    SET_TOTAL (state, data) { state.total = data },
    SET_LOADING (state, data) { state.loading = data },
    SET_ERROR (state, data) { state.error = data }
}

const actions = {
    fetchUsage ({ commit }, params) {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)

        return _axios.get('/api/v1/reports/informa-usage', {
            params: {
                end_date: moment(params.end).format('YYYY-MM-DD'),
                api_type_ids: params.api_type_ids?.length
                    ? params.api_type_ids
                    : undefined,
                page: params.page || 1
            }
        })
            .then(resp => {
                commit('SET_USAGE', resp.data?.data || [])
                commit('SET_CURRENT_PAGE', resp.data?.current_page || 1)
                commit('SET_LAST_PAGE', resp.data?.last_page || 1)
                commit('SET_TOTAL', resp.data?.total || 0)
            })
            .catch(() => {
                commit('SET_ERROR', 'Failed to load usage')
                commit('SET_USAGE', [])
            })
            .finally(() => commit('SET_LOADING', false))
    },

    fetchSummary ({ commit }, params) {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)

        return _axios.get('/api/v1/reports/informa-usage-summary', {
            params: {
                start_date: moment(params.start).format('YYYY-MM-DD'),
                end_date: moment(params.end).format('YYYY-MM-DD')
            }
        })
            .then(resp => {
                commit('SET_SUMMARY', resp.data?.data || [])
            })
            .catch(() => {
                commit('SET_ERROR', 'Failed to load summary')
                commit('SET_SUMMARY', [])
            })
            .finally(() => commit('SET_LOADING', false))
    },

    fetchBalance ({ commit }) {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)

        return _axios.get('/api/v1/reports/informa-balance')
            .then(resp => {
                commit('SET_BALANCE', resp.data?.data?.balance || 0)
                commit('SET_PAYMENT_TYPE', resp.data?.data?.payment_type || '')
            })
            .catch(() => {
                commit('SET_ERROR', 'Failed to load balance')
                commit('SET_BALANCE', 0)
                commit('SET_PAYMENT_TYPE', '')
            })
            .finally(() => commit('SET_LOADING', false))
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
